import {
  BaseWebComponentController,
  IListenerConfig,
  WebComponentEvent,
} from '../../../framework/BaseWebComponentController';
import accountsGridTemplate from '../view/template';
import { AccountsGridView } from '../view/AccountsGridView';
import { AccountsGridRepository } from '../repository/AccountsGridRepository';
import { AccountsGridWebComponent } from '../component/AccountsGridWebComponent';
import { AccountsGridViewData } from '../types';
import { GridEvents } from '../../../grid/types/common';
import { ButtonEvents } from '../../../ui/gzButton/types';

export class AccountsGridController extends BaseWebComponentController {
  public dataRepository: AccountsGridRepository;
  public view: AccountsGridView;

  private selectedItemsData: [];

  constructor(component: AccountsGridWebComponent) {
    super(component);

    this.initialSetup({
      dataRepositoryConstructor: AccountsGridRepository,
      viewConstructor: AccountsGridView,
      viewTemplate: accountsGridTemplate,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    this.view.dom.$gridView.onDataLoadingFinishedWithError = error => this.view.setGridErrorMessage(error);

    return [
      {
        element: this.view.dom.$addAccountButton,
        event: 'click',
        callback: () => {
          this.view.openAddAccountWindow();
        },
      },
      {
        element: this.view.dom.$gridView,
        event: GridEvents.SELECT_ROWS,
        callback: this.changeGridHeaderActionsAvailability,
      },
      {
        element: this.view.dom.$deleteAccountButton,
        event: ButtonEvents.CLICK,
        callback: this.preDelete,
      },
    ];
  }

  async getDataForView(): Promise<AccountsGridViewData> {
    return this.dataRepository.getDataForView();
  }

  private changeGridHeaderActionsAvailability(event: WebComponentEvent): void {
    this.selectedItemsData = event.detail.selectedItemsData;

    this.view.updateDeleteBtnAvailability(this.selectedItemsData);
  }

  private async preDelete() {
    if (this.selectedItemsData.length === 0) {
      return;
    }

    this.view.dom.$deleteAccountButton.setLoadingState(true);

    const deletedUserIds: string[] = this.selectedItemsData.map(({ _id }) => _id);
    const affectedDescendantsCount = await this.dependencies.api.clients.Users.numberOfCompaniesWhereUsersAreMdrContact(
      deletedUserIds
    ).toPromise();

    if (affectedDescendantsCount) {
      this.view.showDeleteAccountMdrWarningWindow(deletedUserIds, affectedDescendantsCount);
    } else {
      this.showDeleteAccountConfirmationWindow();
    }

    this.view.dom.$deleteAccountButton.setLoadingState(false);
  }

  private showDeleteAccountConfirmationWindow() {
    this.view.showDeleteAccountConfirmationWindow(this.selectedItemsData);
  }
}
